export default __webpack_public_path__ + "static/media/think-research.png";